import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div<{ width?: string | number }>(props => ({
    display: "inline-flex",
    verticalAlign: "top",
    width: props.width,
    position: "relative",
}));

export const TextLengthInfo = styled.span(props => ({
    color: theme(props).typography.inactive.color,
    position: "absolute",
    right: 8,
    bottom: 6,
    zIndex: 2,
    backgroundColor: "transparent",
    padding: "0 4px",
}));

export const CurrentLength = styled.span<{ error?: boolean }>(
    props =>
        props.error && {
            color: theme(props).semanticColors.danger.color,
            fontWeight: 600,
        }
);
